import css from '../tpl-css/style-section-grid-item-kynorelle-04.js';
const html = `
<style>${css}</style>
<div
  data-attribute="card-container"
  data-id="unique-id"
  data-background="#003568"
  data-top-padding="true"
  data-bottom-padding="true"
  data-color="#ffffff"
  style="background-color: #003568; color: #ffffff; --text-color: #ffffff;"
>
  <div data-attribute="container" class="container">
    <div class="wrap-card">
      <div data-show="true" data-attribute="title-card" class="title-card">
        <h2><span style="color:hsl(0,0%,100%);">WHAT THEY SAID AFTER WEARING IT FOR THE FIRST TIME</span></h2>
      </div>
      <div class="wrap-grid">
        <div class="swiper">
          <div
            data-attribute="list-item"
            class="swiper-wrapper"
            id="swiper-wrapper-unique-id"
            aria-live="polite"
          >
            <div
              data-attribute="item"
              class="swiper-slide"
              role="group"
              aria-label="1 / 3"
              style="width: 367px; margin-right: 30px;"
            >
              <div class="wrap-item">
                <div data-attribute="content-review" class="content-review">
                  <p style="text-align:center;">
                    “I put these on this morning and didn’t adjust once all day. Usually I’m pulling at my waistband
                    every hour… this just stayed perfect.”
                  </p>
                </div>
                <div class="wrap-img">
                  <img
                    data-attribute="image-item"
                    src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0ead3ac73408c13aa9807.png"
                    alt=""
                  />
                </div>
                <div data-attribute="reviewer-name" class="reviewer-name">
                  Laura K.
                </div>
                <div class="verified">
                  <span class="icon"
                    ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.975 0L9.60625 1.8125L11.9625 1.0875L12.5063 3.44375L14.8625 3.9875L14.1375 6.34375L15.95 7.975L14.1375 9.60625L14.8625 11.9625L12.5063 12.5063L11.9625 14.8625L9.60625 14.1375L7.975 15.95L6.34375 14.1375L3.9875 14.8625L3.44375 12.5063L1.0875 11.9625L1.8125 9.60625L0 7.975L1.8125 6.34375L1.0875 3.9875L3.44375 3.44375L3.9875 1.0875L6.34375 1.8125L7.975 0Z"
                        fill="#42ADA4"
                      ></path>
                      <path
                        d="M11.8175 4.56738L6.88753 9.49738L4.85753 7.46738L3.84253 8.48238L6.88753 11.5274L12.8325 5.58238L11.8175 4.56738Z"
                        fill="#E3F2FD"
                      ></path>
                    </svg>
                  </span>
                  <span>verified buyer</span>
                </div>
              </div>
            </div>

            <div
              data-attribute="item"
              class="swiper-slide"
              role="group"
              aria-label="2 / 3"
              style="width: 367px; margin-right: 30px;"
            >
              <div class="wrap-item">
                <div data-attribute="content-review" class="content-review">
                  <p style="text-align:center;">
                    “The moment I tried them on, I could feel the difference. Soft, light, and somehow they just fit
                    better than anything I’ve worn before.”
                  </p>
                </div>
                <div class="wrap-img">
                  <img
                    data-attribute="image-item"
                    src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0ead8ade7854b6270cd0a.png"
                    alt=""
                  />
                </div>
                <div data-attribute="reviewer-name" class="reviewer-name">
                  Melissa R.
                </div>
                <div class="verified">
                  <span class="icon"
                    ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.975 0L9.60625 1.8125L11.9625 1.0875L12.5063 3.44375L14.8625 3.9875L14.1375 6.34375L15.95 7.975L14.1375 9.60625L14.8625 11.9625L12.5063 12.5063L11.9625 14.8625L9.60625 14.1375L7.975 15.95L6.34375 14.1375L3.9875 14.8625L3.44375 12.5063L1.0875 11.9625L1.8125 9.60625L0 7.975L1.8125 6.34375L1.0875 3.9875L3.44375 3.44375L3.9875 1.0875L6.34375 1.8125L7.975 0Z"
                        fill="#42ADA4"
                      ></path>
                      <path
                        d="M11.8175 4.56738L6.88753 9.49738L4.85753 7.46738L3.84253 8.48238L6.88753 11.5274L12.8325 5.58238L11.8175 4.56738Z"
                        fill="#E3F2FD"
                      ></path>
                    </svg>
                  </span>
                  <span>verified buyer</span>
                </div>
              </div>
            </div>

            <div
              data-attribute="item"
              class="swiper-slide"
              role="group"
              aria-label="3 / 3"
              style="width: 367px; margin-right: 30px;"
            >
              <div class="wrap-item">
                <div data-attribute="content-review" class="content-review">
                  <p style="text-align:center;">
                    “I wore them from errands to dinner and forgot I even had them on. No pressure, no tightness — just
                    easy all day.”
                  </p>
                </div>
                <div class="wrap-img">
                  <img
                    data-attribute="image-item"
                    src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0eae04438269417e5280e.png"
                    alt=""
                  />
                </div>
                <div data-attribute="reviewer-name" class="reviewer-name">
                  Diane H.
                </div>
                <div class="verified">
                  <span class="icon"
                    ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.975 0L9.60625 1.8125L11.9625 1.0875L12.5063 3.44375L14.8625 3.9875L14.1375 6.34375L15.95 7.975L14.1375 9.60625L14.8625 11.9625L12.5063 12.5063L11.9625 14.8625L9.60625 14.1375L7.975 15.95L6.34375 14.1375L3.9875 14.8625L3.44375 12.5063L1.0875 11.9625L1.8125 9.60625L0 7.975L1.8125 6.34375L1.0875 3.9875L3.44375 3.44375L3.9875 1.0875L6.34375 1.8125L7.975 0Z"
                        fill="#42ADA4"
                      ></path>
                      <path
                        d="M11.8175 4.56738L6.88753 9.49738L4.85753 7.46738L3.84253 8.48238L6.88753 11.5274L12.8325 5.58238L11.8175 4.56738Z"
                        fill="#E3F2FD"
                      ></path>
                    </svg>
                  </span>
                  <span>verified buyer</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
